import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";

import axios from "axios";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "./UserRights.css";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Changes from "../../common/Changes";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    minWidth: 120,
  },
}));
export default function ProfileStraight(props) {
  const classes = useStyles();
  const [idSport, setIdSport] = useState(["CBB"]);
  const [period, setPeriod] = useState(["0"]);
  const [selectedApp, setSelectedApp] = useState(0);
  const [rights, setRights] = useState();
  const [userRights, setUserRights] = useState();
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );

  useEffect(() => {
    // Change for server api address
    GetRights(selectedApp);
    GetUserRights(selectedApp);
  }, []);
  const GetRights = (idApp) => {
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/User/UserRights_GetListForApp?idApp=" +
        idApp,
      //url: 'https://localhost:44337/api/User/UserRights_GetListForApp?idApp=' + idApp,
    }).then((response) => {
      setRights(response.data);
      console.log("response", response);
    });
  };

  const GetUserRights = (idApp) => {
    axios({
      method: "get",
      url:
        process.env.REACT_APP_API2_URL +
        "/User/UserRights_GetUserRights?idUser=" +
        props.sysUser.idUser +
        "&idApp=" +
        idApp,
      //url:'https://localhost:44337/api/User/UserRights_GetUserRights?idUser=' +props.sysUser.IdUser +'&idApp=' +idApp,
    }).then((response) => {
      let mappedArr = response.data.map((x) => {
        return {
          Id: x.idRight,
        };
      });
      let array = [];
      mappedArr.forEach((element) => array.push(element.Id));
      setUserRights(array);
      console.log("response", response);
    });
  };

  const handleChange = (event) => {
    setSelectedApp(event.target.value);
    GetRights(event.target.value);

    GetUserRights(event.target.value);
  };

  const handleRightChange = (action, requestDTO) => {
    const url =
      action === "add"
        ? process.env.REACT_APP_API2_URL + "/User/UserRights_AddRight"
        : process.env.REACT_APP_API2_URL + "/User/UserRights_RemoveRight";

    return axios({
      method: "post",
      url: url,
      data: requestDTO,
    }).then((response) => {
      if (response.data === 0) {
        alert(
          action === "add"
            ? "Right Successfully Added"
            : "Right Successfully Removed"
        );
        GetRights(selectedApp);
        GetUserRights(selectedApp);
      }
    });
  };

  const onRowSelect = (row, isSelected, e) => {
    let RequestDTO = [{
      AppId: selectedApp,
      userId: props.sysUser.idUser,
      IdRight: row.idRight,
      IdForm: 1,
      IdUser: userInfo.userId,
    }];
    // let RequestDTO = {
    //   AppId: selectedApp,
    //   userId: props.sysUser.IdUser,
    //   IdRight: row.IdRight,
    //   IdForm: 1,
    //   IdUser: userInfo.userId,
    // };
    if (isSelected) {
      handleRightChange("add", RequestDTO);
      // axios({
      //   method: "post",
      //   url: process.env.REACT_APP_API2_URL + "/User/UserRights_AddRight",
      //   //url: 'https://localhost:44337/api/User/UserRights_AddRight',
      //   data: RequestDTO,
      //   /*  REPLACE WITH SELECT DATA */
      // }).then((response) => {
      //   if (response.data === 0) {
      //     alert("Right Successfully Added");
      //     GetRights(selectedApp);

      //     GetUserRights(selectedApp);
      //   }
      // });
    } else if (!isSelected) {
      handleRightChange("remove", RequestDTO);
      // axios({
      //   method: "post",
      //   url: process.env.REACT_APP_API2_URL + "/User/UserRights_RemoveRight",
      //   //url: 'https://localhost:44337/api/User/UserRights_RemoveRight',
      //   data: RequestDTO,
      // }).then((response) => {
      //   if (response.data === 0) {
      //     alert("Righta Successfully Removed");
      //     GetRights(selectedApp);

      //     GetUserRights(selectedApp);
      //   }
      // });
    }
  };

  const selectRowProp = {
    mode: "checkbox",
    selected: userRights,
    onSelect: onRowSelect,
    onSelectAll: (isSelected, rows) => {

      if (isSelected) {
        const rightsArray = rows.map((row) => ({
          AppId: selectedApp,
          userId: props.sysUser.idUser,
          IdRight: row.idRight,
          IdForm: 1,
          IdUser: userInfo.userId,
        }));
        console.log("Se seleccionaron todas las filas:", rows);
        console.log("Agregando todos los permisos:", rightsArray);
        handleRightChange("add", rightsArray);
      } else {
        const rightsToRemove = rows.filter((row) => userRights.includes(row.idRight));
        const rightsArray = rightsToRemove.map((row) => ({
          AppId: selectedApp,
          userId: props.sysUser.idUser,
          IdRight: row.idRight,
          IdForm: 1,
          IdUser: userInfo.userId,
        }));
        console.log("Se deseleccionaron todas las filas.", rows);
        console.log("Permisos a remover:", rightsArray);
        handleRightChange("remove", rightsArray);
      }
    },
  };

  const options = {
    page: 1, // which page you want to show as default
    sizePerPageList: [
      {
        text: "15",
        value: 15,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ], // you can change the dropdown list for size per page
    sizePerPage: 22, // which size per page you want to locate as default
    pageStartIndex: 1, // where to start counting the pages
    paginationSize: 1, // the pagination bar size.
    prePage: "Prev", // Previous page button text
    nextPage: "Next", // Next page button text
    firstPage: "First", // First page button text
    lastPage: "Last", // Last page button text
    paginationShowsTotal: true, // Accept bool or function
    paginationPosition: "bottom", // default is bottom, top and both is all available
    // hideSizePerPage: true > You can hide the dropdown for sizePerPage
    // alwaysShowAllBtns: true // Always show next and previous button
    withFirstAndLast: false, // Hide the going to First and Last page button

    //onRowClick: selectedValues,
  };

  return (
    <div className="flex flex-col gap-4 h-max">
      <div className="web-options">
        <FormControl
          className={`${classes.formControl} w-full`}
          size="small"
          variant="outlined"
        >
          <InputLabel shrink id="demo-simple-select-placeholder-label-label">
            Application
          </InputLabel>

          <Select
            labelId="demo-simple-select-placeholder-label-label"
            id="demo-simple-select-placeholder-label"
            //value={sports[0] && sports[0]['IdSport']}
            value={selectedApp}
            onChange={handleChange}
            displayEmpty
          >
            <MenuItem value={0}>BET TICKER</MenuItem>
            <MenuItem value={1}>BONUS POINTS</MenuItem>
            <MenuItem value={2}>CLIENT</MenuItem>
            <MenuItem value={3}>CUSTOMER SERVICE</MenuItem>
            <MenuItem value={4}>GAME IMPORTER</MenuItem>
            <MenuItem value={5}>MANAGER</MenuItem>
            <MenuItem value={6}>LINEMANAGER</MenuItem>
            <MenuItem value={7}>REPORTER</MenuItem>
            <MenuItem value={8}>DBSGAMEIMPORTER</MenuItem>
            <MenuItem value={9}>BRGAMEIMPORTER</MenuItem>
            <MenuItem value={10}>SOGAMEIMPORTER</MenuItem>
            <MenuItem value={11}>DBSGAMEIMPORTERSVC</MenuItem>
            <MenuItem value={12}>BRGAMEIMPORTERSVC</MenuItem>
            <MenuItem value={13}>SOGAMEIMPORTERSVC</MenuItem>
            <MenuItem value={14}>LANGCONFIG</MenuItem>
            <MenuItem value={15}>ENCRYPTER</MenuItem>
            <MenuItem value={16}>LAUNCHER</MenuItem>
          </Select>
        </FormControl>

        <Changes
          title="User Rights Changes"
          params={{
            ChangeType: 4,
            IdSport: "",
            Param1: props.sysUser.idUser,
            Param2: 0,
            Param3: 0,
          }}
        />
      </div>
      <BootstrapTable
        data={rights}
        options={options}
        selectRow={selectRowProp}
        version="4"
        hover
      >
        <TableHeaderColumn visible="none" hidden isKey dataField="idRight">
          IdRight
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="description"
          filter={{ type: "TextFilter", delay: 1000 }}
        >
          Description
        </TableHeaderColumn>
      </BootstrapTable>
    </div>
  );
}
